import { GetRole } from "@/api/user";
    const state = {
        count: 2,
        bMaintenanceId:'',
        bOwnerId:'',
        mobile:'',
        permissions:'',
        userType:'',
    };
    const mutations={
        increment (state) {
            state.count++
        }
    };
    const actions={
        increment (context) {
            context.commit('increment')
            console.log(2222)
        }
    }
// const getters={
//     // getUsers(state){ //获取访问该页面的所有用户
//     //     return state.users;
//     // }
// };
// const mutations={
//     // getUser(state,name){ //查询用户
//     //     User()
//     // }
//     getUser(content, resData) {
//         return new Promise((resolve, reject) => {
//             GetRole().then(res => {
//                 // let role = res.data.data;
                
//                 // content.commit("SET_ROLES", role.role);
//                 console.log(role);
//                 resolve(role)
//             }).catch(error => {
//                 console.log(error);
//             })
//         })
//     },
//  };
// const actions={
//     invokeAddUser(context,name){ //触发mutations里面的addUser,传入数据形参name对应到users
//         context.commit('getUser',name);
//     }
// };

const store = {
    namespaced:true,
    state,
    // getters,
    mutations,
    actions
}
export default store;


// WEBPACK FOOTER //
// ./src/store/modules/user.js